import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import React from "react";
import type { RelocationReferrer } from "../../../RelocationRequestWidget";
import { OverviewStepContent } from "./OverviewStepContent";

interface OverviewStepProps {
  compact?: boolean;
  referrer: RelocationReferrer;
}

export const OverviewStep: React.FC<OverviewStepProps> = (props) => {
  return (
    <WizardStep id="overview" indicatorText="overview" stepWillSubmitForm>
      <OverviewStepContent compact={props.compact} referrer={props.referrer} />
    </WizardStep>
  );
};
